module.exports = __webpack_public_path__ + "media/src/images/buttons/apple_pay-d92f592e83008ea55a289a3b70803e1a.svg";